import React from 'react';
export const getShape = function () {
  let shape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'circle';
  let color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (shape === 'square') {
    return React.createElement("path", {
      d: "M71.5833 88.9284L8.45186 78.6288C5.53361 78.143 3.58811 75.4224 4.07449 72.5074L14.2884 9.44686C14.7747 6.53189 17.4984 4.58857 20.4167 5.0744L83.5481 15.374C86.4664 15.8598 88.4119 18.5804 87.9255 21.4954L77.7116 84.4588C77.3225 87.3737 74.5016 89.4142 71.5833 88.9284Z",
      fill: color
    });
  }
  if (shape === 'triangle') {
    return React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.4171 7.53779L87.482 67.5489C90.3281 69.8894 90.8455 74.3832 88.6032 77.3791C87.5683 78.7834 86.1021 79.7196 84.4635 80.0005L22.1092 89.9243C18.5732 90.486 15.2959 87.8647 14.7785 83.9326C14.7785 83.9326 14.7785 83.9326 14.7785 83.839L6.06784 13.9976C5.55037 10.1592 8.05144 6.60158 11.5874 6.03985C13.3123 5.85261 15.0372 6.32072 16.4171 7.53779Z",
      fill: color
    });
  }
  return React.createElement("path", {
    d: "M48 90c23.196 0 42-18.804 42-42S71.196 6 48 6 6 24.804 6 48s18.804 42 42 42Z",
    fill: color
  });
};
export const getBackgroundColor = function () {
  let shape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'circle';
  let neutral = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return "var(--spots-background-".concat(neutral ? 'neutral' : shape, ")");
};
export const getColor = function () {
  let shape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'circle';
  let neutral = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return "var(--spots-color-".concat(neutral ? 'neutral' : shape, ")");
};
export const getBorderColor = function () {
  let neutral = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return "var(--spots-border-color-".concat(neutral ? 'neutral' : 'default', ")");
};